<template>
  <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      errorMessage: function(state) {
        return state.drops.purchaseError
      }
    })
  }
}
</script>
<style scoped lang="scss">
.error {
  font-family: $font-family-primary;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  margin: 10px 0;
  line-height: 40px;
  color: #B00020;
}

</style>